const CustomerAccountIcon = ({ ...props }) => {
  const color = props?.color || "#05383f";
  const size = props?.size || "25px";
  const fileSrc = "/public/icon/customerAccount.svg";
  return (
    <div
      style={{
        width: size,
        height: size,
        display: "inline-block",
        verticalAlign: "middle",
        backgroundColor: color,
        maskImage: "url(" + fileSrc + ")",
        maskSize: "contain",
        WebkitMaskImage: "url(" + fileSrc + ")",
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
      }}
    />
  );
};

export default CustomerAccountIcon;
